import {useLocation} from 'react-router-dom';

export default function URIParameterHelper(parameter){
    const {search} = useLocation();
    const regExp = new RegExp(parameter + "=(.*)");
    const match = search.match(regExp);
    const searchVal = match?.[1];
    return searchVal; 
}